import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';

@Component({
  selector: 'date-of-birth',
  template: `<form #dateOfBirthForm="ngForm">
                <div class="form-group">
                  <label for="dateOfBirth">{{ 'dateOfBirth.dateOfBirthLabel' | translate }} (MM-DD-YYYY)</label>
                  <input type="text" class="form-control" id="dateOfBirth"
                          [required]="required"
                          placeholder="MM-DD-YYYY"
                          [(ngModel)]="displayDate" name="dateOfBirth"
                          (ngModelChange)="onInputChange(dateOfBirthField)"
                          #dateOfBirthField="ngModel">

                  <div *ngIf="dateOfBirthField.invalid && (dateOfBirthField.dirty || dateOfBirthField.touched)"
                       class="alert alert-danger">
                    <div *ngIf="dateOfBirthField.errors?.required">
                      {{ 'dateOfBirth.dateOfBirthRequiredMessage' | translate }}
                    </div>
                    <div *ngIf="dateOfBirthField.errors?.invalidFormat">
                      {{ 'dateOfBirth.dateOfBirthInvalidFormatMessage' | translate }}
                    </div>
                  </div>
                </div>
              </form>`,
})
export class DateOfBirthComponent {
  invalidDateValue: boolean = false;

  @Input() required: boolean = true;
  @Input() dateOfBirth: string; // Holds the date in ISO format (YYYY-MM-DD)
  @Output() dateOfBirthChange = new EventEmitter<string>();

  displayDate: string; // Holds the date in MM-DD-YYYY format for display

  @ViewChild(NgForm) form;

  ngOnInit() {
    if (this.dateOfBirth) {
      this.displayDate = this.formatDateToMMDDYYYY(this.dateOfBirth);
    }
  }

  onInputChange(dateOfBirthField: NgModel) {

    if (!this.validateDateFormat(this.displayDate)) {
      dateOfBirthField.control.setErrors({ invalidFormat: true });
      return;
    }

    const parsedDate = this.parseDate(this.displayDate);
    const fullYear = parsedDate.getFullYear();

    if (fullYear >= 1900 && fullYear <= 2999) {
      // Valid year
      const isoDate = this.formatDateToISO(parsedDate);
      this.dateOfBirthChange.emit(isoDate);
      this.dateOfBirth = isoDate;

      // Clear custom errors
      dateOfBirthField.control.setErrors(null);
    } else {
      // Invalid year sets invalidFormat
      dateOfBirthField.control.setErrors({ invalidFormat: true });
    }
  }

  validateDateFormat(dateString: string): boolean {
    // Matches MM-DD-YYYY
    const regex = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/;
    return regex.test(dateString);
  }

  parseDate(dateString: string): Date | null {
    const parts = dateString.split('-');
    if (parts.length !== 3) {
      return null;
    }

    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const date = new Date(year, month - 1, day);

    // Check if the constructed date matches the input date components
    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {
      return date;
    } else {
      return null;
    }
  }

  formatDateToISO(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  formatDateToMMDDYYYY(isoDate: string): string {
    const date = new Date(isoDate);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }
}


